<div *ngIf="tourService!=null&&tourService.isShow!=null">
    <div class="tour-background" id="tour-background-btn" [ngClass]="{'tour-hide': tourService.isShow==false}"
        [style]="tourService.positionStyle" [ngbPopover]="popContent" #Descriptionpopup="ngbPopover"
        [autoClose]="false">

    </div>
    <div class="tour-foreground" [style]="tourService.popoverPositionStyle">

        <ng-template class="pendar-datapicker-popover template-shown" #popContent>
            <div class="tour-body">
                <div class="tour-header">
                    <h6>{{ tourService.tourItems[tourService.thisTourIndex] | translateData:'title' }}</h6>
                </div>
                <div class="tour-content">
                    <p>
                        {{ tourService.tourItems[tourService.thisTourIndex] | translateData :'content' }}
                    </p>
                </div>
                <div class="button-box-tour">
                    <button type="button" class="btn btn-sm btn-label-secondary mx-2"
                        (click)="skip(Descriptionpopup)">skip</button>
                    <button type="button" *ngIf="tourService.tourItems.length>tourService.thisTourIndex+1"
                        class="btn btn-sm btn-primary mx-2" (click)="next(Descriptionpopup)">Next</button>
                    <button type="button" *ngIf="tourService.tourItems.length==tourService.thisTourIndex+1"
                        class="btn btn-sm btn-label-secondary mx-2" (click)="skip(Descriptionpopup)">Finish</button>
                </div>
            </div>
        </ng-template>
    </div>
</div>